export default {
  namespaced: true,

  state: {
    visible: false,
    title: '',
    content: '',
    buttons: []
  },

  mutations: {
    open (state, options) {
      Object.assign(state, options)
      state.visible = true
    },

    close (state) {
      state.visible = false
    }
  }
}
